import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import '../Videos.scss'
import { HowToVideo } from '../../../../../services/cellcast.type'
import { getCategoryDisplayName, getVideoThumbnail } from "../../../../Utils/videoUtils";

type Props = {
  imagePath: string
  title: string
  iconPath?: string
  description: string
  footerText: string,
  category: string,
  article: string,
  item: HowToVideo,
  onBackToList: () => void,
  onCategoryClick: (category: string) => void,
  onClickActionButton?: (() => void) | null
}

const VideoDetail: React.FC<Props> = ({
  imagePath,
  title,
  description,
  footerText,
  onBackToList, 
  onCategoryClick,
  category,
  article,
  item
}) => {
  return (
    <div className="space-y-6 container">
      <div className='background-white p-6'>
              {/* Breadcrumb Navigation */}
      <nav className="flex items-center space-x-2 text-sm">
        <button 
          onClick={onBackToList}
          className="text-muted-foreground fw-bolder"
        >
          Video Library
        </button>
        <span>/</span>
        <button 
          onClick={() => onCategoryClick(category)}
          className="text-muted-foreground fw-bolder"
        >
          {getCategoryDisplayName(category)}
        </button>
        <span>/</span>
        <span className="text-muted-foreground">
          {title}
        </span>
      </nav>

      {/* Back Button */}
      <button 
        onClick={onBackToList}
        className="flex items-center gap-2 px-3 mb-5 mt-5 border border-border rounded bg-background hover:bg-accent btn btn-primary"
      >
        <KTSVG path="/media/icons/duotune/arrows/arr002.svg" className="svg-icon-1 pe-1" />
        Back to Videos
      </button>

      {/* Video Player */}
      <div className="card rounded-4 overflow-hidden">
        {item.videoUrl ? (
          <iframe
            src={item.videoUrl}
            title={item.title}
            className="w-full h-full"
           height='470px'
           allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
           referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          />
        ) : (
          <div className="h-full flex items-center justify-center">
            <div className="text-center">
              <img src={imagePath} alt={title} className='w-full object-cover mt-3 max-h-200' style={{maxHeight: 400, borderRadius: 8}} />
            </div>
          </div>
        )}
      </div>

      {/* Video Information */}
      <div className="space-y-4">
        <div className="d-flex align-items-stretch flex-lg-grow-1 mt-4 mb-4">
          <span className="bg-primary text-white px-2 mr-3 py-1 rounded text-xs" style={{marginRight: 15}}>
            {getCategoryDisplayName(category)}
          </span>
          {/* <div className="flex items-center gap-1 text-sm text-muted-foreground" style={{ marginRight: 15 }}>
            <KTSVG path="/media/icons/duotune/general/gen007.svg" className="w-4 h-4"  style={{ color: '#7950F2' }}/>
            05:00
          </div> */}
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <KTSVG path="/media/icons/duotune/general/gen014.svg" className="w-4 h-4 px-1"  style={{ color: '#7950F2' }} />
            {item.updatedAt && new Date(item.updatedAt).toLocaleDateString()}
          </div>
        </div>

        <h1>{title}</h1>
        {article && (
          <div className=" rounded-lg p-4 bg-white">
            <div className="text-sm  bg-white mb-1">From Article:</div>
            <div className="font-medium">{article}</div>
          </div>
        )}

        <div className='mt-4 mb-4'>
          <p className="text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>

         {footerText && (
          <div className="text-sm text-muted-foreground">
            {footerText}
          </div>
        )}

      </div>
      </div>
    </div>
  )
}

export default VideoDetail
